import { Slice } from './types'

export const getSlice = (state: any): Slice => {
  return state.customer.resetPassword
}
